<template>
  <div class="node-body">
    <article-body v-if="nodeType === 'article'" :nid="nid"></article-body>
    <person-body v-else-if="nodeType === 'person'" :nid="nid"></person-body>
    <comparison-body v-else :nid="nid"></comparison-body>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import EventBus from 'components/helpers/event-bus'

  export default {
    name: 'node-body',
    props: ['nid', 'cover'],
    components: {
      ArticleBody: () => import('components/node/article/ArticleBody.vue'),
      ComparisonBody: () => import('components/node/comparison/ComparisonBody.vue'),
      PersonBody: () => import('components/node/person/PersonBody.vue'),
      PageBody: () => import('components/node/page/PageBody.vue'),
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      nodeType() {
        // Need to change this because comparison API didnt return the type
        return get(this, 'node.type', 'comparison')
      },
    },
    mounted () {
      if (!get(EventBus, '_events.nodeBodyMounted')) {
        EventBus.$on('nodeBodyMounted', () => {
          EventBus.$emit('bodyMounted')
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// NodeBody.vue?5d921a39